import type { LucideIcon } from 'lucide-react'

interface IconContainerProps {
  icon: LucideIcon
  size?: 'sm' | 'md' | 'lg'
  variant?: 'primary' | 'secondary' | 'gradient' | 'muted'
  rounded?: boolean
  className?: string
}

const IconContainer = ({ 
  icon: Icon, 
  size = 'md', 
  variant = 'gradient',
  rounded = false,
  className = ''
}: IconContainerProps) => {
  const sizeClasses = {
    sm: { container: 'w-8 h-8', icon: 'w-4 h-4' },
    md: { container: 'w-12 h-12', icon: 'w-6 h-6' },
    lg: { container: 'w-16 h-16', icon: 'w-8 h-8' }
  }
  
  const variantClasses = {
    primary: 'bg-primary text-primary-foreground',
    secondary: 'bg-secondary text-secondary-foreground',
    gradient: 'bg-gradient-to-br from-blue-100 to-purple-100 text-blue-500',
    muted: 'bg-gray-100 text-gray-400'
  }
  
  const roundedClass = rounded ? 'rounded-full' : 'rounded-lg'
  const { container, icon } = sizeClasses[size]
  const variantClass = variantClasses[variant]
  
  return (
    <div className={`${container} ${variantClass} ${roundedClass} flex items-center justify-center shadow-sm ${className}`}>
      <Icon className={icon} />
    </div>
  )
}

export default IconContainer

